import { useEffect } from 'react';
import { Operation } from 'hooks/store/types';
import { ActionTypes, leaveProject } from 'store/data/projects';
import { useDispatch, usePrevious } from 'hooks/utils';
import { useTranslation } from 'hooks/store';
import { useActivity } from 'hooks/store/utils/useActivity';
import { useAlerts } from 'hooks/ui';

export function useLeaveProject(): Operation<(projectId: string) => void> {
	const dispatch = useDispatch();
	const { translate } = useTranslation();
	const { setNotification } = useAlerts();

	const [{ loading, error }] = useActivity(ActionTypes.LEAVE_PROJECT);

	const wasLoading = usePrevious(loading);
	useEffect(() => {
		if (wasLoading && !loading && !error) {
			setNotification({
				message: translate(dict => dict.leaveProject.projectLeftSuccessfully)
			});
		}
	}, [loading, error]);

	function handler(projectId: string) {
		dispatch(leaveProject(projectId));
	}

	return [{ loading, error }, handler];
}
